import { TextPhase } from "@/pages/sources/components/create/sources/text/types";

export enum TextActionType {
  SET_SOURCE_NAME = "SET_SOURCE_NAME",
  SET_TEXT_CONTENT = "SET_TEXT_CONTENT",
  SET_SHOULD_SHOW_ERRORS = "SET_SHOULD_SHOW_ERRORS",
  SET_PHASE = "SET_PHASE",
  SET_ERROR = "SET_ERROR",
}

export interface SetSourceNameAction {
  type: TextActionType.SET_SOURCE_NAME;
  payload: string;
}

export interface SetTextContentAction {
  type: TextActionType.SET_TEXT_CONTENT;
  payload: string;
}

export interface SetShouldShowErrorsAction {
  type: TextActionType.SET_SHOULD_SHOW_ERRORS;
  payload: boolean;
}

export interface SetPhaseAction {
  type: TextActionType.SET_PHASE;
  payload: TextPhase;
}

export interface SetErrorAction {
  type: TextActionType.SET_ERROR;
  payload: string | null;
}

export type TextAction =
  | SetSourceNameAction
  | SetTextContentAction
  | SetShouldShowErrorsAction
  | SetPhaseAction
  | SetErrorAction;
